import { Component, OnInit, Output, EventEmitter, ViewChild, Sanitizer, ElementRef, ChangeDetectorRef, Inject, AfterViewInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
import { Router, ActivatedRoute } from '@angular/router';
//import { RequestMetadata, PagedResult } from '../../../../lib/ng-crud-table';
import { MatTableDataSource, fadeInContent } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator } from '@angular/material';
import { Row } from 'lib/ng-data-table';
import { SelectItem, Keys } from 'lib/common';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { NgSwitchCase, DOCUMENT } from '@angular/common';
import { validateBasis } from '@angular/flex-layout';
import { AppComponent } from 'src/app/app.component';
import { SystemSettingConfig } from 'src/app/shared/models/SystemSettingConfig';
import { SystemSettingsService } from 'src/app/shared/services/system-settings/system-settings.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  title: string = "Login";
  staticScreen = true;
  @Output() childTitleEvent = new EventEmitter();

  baseUrl: string;
  url: string;
  showError: boolean = false;
  showErrorMsg: string = "";
  emailid: string = "";
  maskedEmailID: string = "";
  ConfirmPin: string;
  versionLabel: string = "6.0";
  username: string = "";
  loading: boolean = false;
  userNameSection: boolean = true;
  titleMessage: string;


  loginDetails = new SystemSettingConfig();
  constructor(private http: HttpClient, private cdr: ChangeDetectorRef, private logservice: SystemSettingsService, private dialog: MatDialog, @Inject(DOCUMENT) private _document: Document, private router: Router, private route: ActivatedRoute) {
    this.baseUrl = environment.urlAddress + '/api/';
    //alert('fp');
  }

  ngOnInit() {
    //alert('forgot');
    this.parentEvent();
  }


  parentEvent() {
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  ReturnToLogin() {
    this.router.navigateByUrl('login');
  }

  validateEmailID() {
    this.showError = false;
    this.showErrorMsg = "";
    debugger;
    if (this.emailid.length == 0) {
      this.showError = true;
      this.showErrorMsg = "* Required";
      return false;
    }
    else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.emailid)) {
        this.showError = true;
        this.showErrorMsg = "enter valid email id";
        return false;
      }
    }

    return true;
  }

  SendLink() {
    //if (!this.validateEmailID())
    //  return;

    this.loading = true;
    this.loginDetails.EmailID = this.emailid;
    try {
      this.url = this.baseUrl + 'Login/ForgotPassword';
      this.ForgotPassword_Service().subscribe((res: any) => {
        //debugger;
        this.loading = false;
        let rows: any = res;//JSON.parse(res) as any;
        if (rows == "success") {
          //alert("We have sent an email with instructions to reset your password.Please check your email inbox or spam folder for further details.");
          this.titleMessage = "A reset password link has been sent to your registered email address '" + this.maskedEmailID + "'";
        }
        else {
          this.showError = true;
          this.showErrorMsg = "email id doesnt exists. please contact your administrator.";
        }
        return false;
      });
    } catch (err) {
      this.loading = false;
    }
  }

  CheckUserName() {
    this.titleMessage = "";
    this.loading = true;
    this.showError = false;
    this.showErrorMsg = "";

    if (this.username.trim() == "") {
      this.showError = true;
      this.showErrorMsg = "* Required";
      return false;
    }
        
    this.loginDetails.UserName = this.username;
    try {
      this.url = this.baseUrl + 'Login/CheckUserName';
      this.ForgotPassword_Service().subscribe((res: any) => {
        //debugger;
        this.loading = false;
        let rows: any = res;//JSON.parse(res) as any;
        if (rows.includes('admin'))//(rows == "success")
        {
           this.maskedEmailID = rows.split('$')[1];
          //this.userNameSection = false;//// commented as it's for enter emaild for reset link to sent to user but now not need that process as per ROB's requirement.
          this.userNameSection = true;
          this.emailid = rows.split('$')[2];
          this.SendLink();
        }
        else if (rows == "user") {
          this.userNameSection = true;
          this.titleMessage = "Please contact the system administrator to reset your password.";
          //alert('Please contact the system administrator to reset your password.');
        }
        else {
          this.userNameSection = true;
          this.showError = true;
          this.showErrorMsg = "username doesnt exists.";
        }
        return false;
      });
    } catch (err) {
      this.loading = false;
    }

  }
  ///////////////////////////////////////// SERVICE
  ForgotPassword_Service() {
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    return this.http.post<any>(this.url, this.loginDetails, options);
  }



}
